import React from 'react';
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({ totalPages, currentPage, action }) => {
  const renderButtons = () => {
    const maxButtons = totalPages >= 5 ? 5 : totalPages;
    const buttons = [];
    buttons.push(
      <Pagination.Item
        key={1}
        active={currentPage === 1}
        onClick={() => action(1)}
      >
        1
      </Pagination.Item>
    );

    if (currentPage > Math.floor(maxButtons / 2) + 2) {
      buttons.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    let start = Math.max(2, currentPage - Math.floor(maxButtons / 2));
    const end = Math.min(
      totalPages - 1,
      currentPage + Math.floor(maxButtons / 2)
    );

    if (start > 2 && end - start + 1 < maxButtons) {
      start = end - maxButtons + 1;
      start = Math.max(start, 2);
    }

    for (let i = start; i <= end; i++) {
      buttons.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => action(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - Math.floor(maxButtons / 2) - 1) {
      buttons.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    if (totalPages > 1) {
      buttons.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages}
          onClick={() => action(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return buttons;
  };

  return totalPages > 1 ? (
    <Pagination bsSize="medium">
      <Pagination.Prev
        onClick={() => action(currentPage - 1)}
        disabled={currentPage === 1}
      />
      {renderButtons()}
      <Pagination.Next
        onClick={() => action(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    </Pagination>
  ) : null;
};

export default CustomPagination;
